import React from "react";
import about from "../../assets/vector/rnd-about.png";
import { FaFlask, FaLightbulb, FaUsers } from "react-icons/fa";
import classes from "./RnDAbout.module.css";

const RnDAbout = () => {
  return (
    <section className={classes.aboutInfo} aria-label="Research and Development Overview">
      {/* Text Content */}
      <div className={classes.aboutText}>
        <p>
          We are an award-winning research and development company who offer
          workshops, practical training, hackathons, bootcamps, internships,
          masterclasses, tech clubs, and talk shows to diploma, bachelors, and
          masters degree students or working professionals to help them
          transition from being unemployed or underemployed to being
          purposefully happy employees, entrepreneurs, or innovators in the 21st
          century. We have not only helped thousands of students and startups in
          various fields like robotics, automation, IoT device development,
          software development, web / mobile app development etc but we also
          have a significant contribution towards Research & Development of
          various Research Papers, Books, Publications, Patented Projects and
          many more.
        </p>

        {/* Stats */}
        <div className={classes.stats}>
          <div className={classes.statCard}>
            <FaFlask className={classes.icon} />
            <h3>20+</h3>
            <p>Research Projects</p>
          </div>

          <div className={classes.statCard}>
            <FaLightbulb className={classes.icon} />
            <h3>10+</h3>
            <p>Patents & Innovations</p>
          </div>

          <div className={classes.statCard}>
            <FaUsers className={classes.icon} />
            <h3>200+</h3>
            <p>Students & Startups Supported</p>
          </div>
        </div>
      </div>

      {/* Image */}
      <div className={classes.aboutImg}>
        <img src={about} alt="Research and Development Illustration" loading="lazy" />
      </div>
    </section>
  );
};

export default RnDAbout;
